import { GridFilterModel } from '@mui/x-data-grid-pro'
import { useState } from 'react'

const useDataGridSearch = () => {
    const [searchText, setSearchText] = useState('')

    const requestSearch = (searchValue: string) => {
        setSearchText(searchValue)
    }

    const filterModel: GridFilterModel = {
        items: [],
        quickFilterValues: [searchText],
    }
    return { searchText, requestSearch, filterModel }
}

export default useDataGridSearch
